import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

const PricingBlock = ({ doc, StartOrderBtn }) => {
  const {
    heading,
    image,
    description,
    price,
    price_heading,
    tag,
    tag_color,
    tag_background_color,
    show_start_an_order,
    button_text,
    button_url,
    internal_link_id,
    currency,
  } = doc?.primary || {};
  return (
    <div className="py-4 py-md-5 bg-white item-price-section prismic-slice">
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width item-price-container">
        <div className="w-100 px-lg-5 px-md-3 d-flex flex-md-row flex-column align-items-center justify-content-between item-price-block">
          <div className="mb-3 mb-md-0 d-flex align-items-center item-image-block">
            <PrismicImgix
              src={image?.url}
              alt={image?.alt}
              desktop="460px"
              mobile="400px"
              tablet="300px"
              largeDisplay="900px"
              lazySizesEnabled={false}
            />
          </div>
          <div className="mt-3 mt-md-0 item-details-block">
            <div className="mb-3 mb-2xl-3 item-details-label-row">
              <span
                className="px-3 px-2xl-3 d-inline-block font-weight-bold text-uppercase text-break ls-1 item-details-label"
                style={{ color: tag_color, background: tag_background_color }}
              >
                {textResolver(tag)}
              </span>
            </div>
            <div className="mb-2 mb-2xl-2 text-theme-primary font-weight-bold sns-h3 item-details-title same-size-title">
              {textResolver(heading)}
            </div>
            <div className="mb-2 mb-2xl-2 font-weight-bold sns-h5 item-details-starting-text">
              {textResolver(price_heading)}
            </div>
            {price && (
              <div className="mt-md-0 mt-1 mb-3 mb-2xl-3 font-weight-bold sns-h2 item-details-price">
                {currency}
                {price}
              </div>
            )}
            <div className="sns-h5 item-details-description">{textResolver(description)}</div>
            <div className="mt-md-4 mt-2xl-4 mt-3 pt-md-2 pt-2xl-2 pt-0 item-details-button-row">
              {show_start_an_order && StartOrderBtn && (
                <StartOrderBtn className="px-5 px-2xl-5 py-3 py-2xl-3 cursor-pointer d-inline-block text-white font-weight-bold no-underline text-uppercase text-break ls-3 button-program-green">
                  {textResolver(button_text)}
                </StartOrderBtn>
              )}
              {!show_start_an_order && (
                <PrismicLinkTag
                  urlText={button_text}
                  url={button_url?.url}
                  target={button_url?.target}
                  className="px-5 px-2xl-5 py-3 py-2xl-3 d-inline-block text-white font-weight-bold no-underline text-uppercase text-break ls-3 button-program-green"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingBlock;
